/**
 * "Geçmişi Göster" ile seçilen lastiğin yeni emanet formundaki lastik
 * listesine yerleştirilmesi.
 *
 * KÖK NEDEN (düzeltilen hata): Yeni Emanet formu daima BİR BOŞ lastik satırıyla
 * ("Lastik #1") açılıyor. Eski kod geçmişten gelen lastiği koşulsuz listenin
 * SONUNA eklediği için #1 boş kalıyor ve kullanıcının seçtiği lastik
 * "Lastik #2" olarak görünüyordu.
 *
 * ÇÖZÜM: ilk DOKUNULMAMIŞ satır varsa oraya yazılır, yoksa yeni satır eklenir.
 * Böylece 1. seçim #1'e, 2. seçim #2'ye gider ve kullanıcının kendi doldurduğu
 * satırların üzerine ASLA yazılmaz.
 *
 * Saf fonksiyon olarak ayrı tutuldu → bileşen render etmeden test edilebiliyor.
 */

/** Satır hiç doldurulmamış mı? Adet/Sezon varsayılanları dolu geldiği için
 *  YALNIZCA kullanıcının girmesi gereken alanlara bakılır. */
export function isBlankTire(t) {
  if (!t) return true;
  return (
    !(t.brand || "").trim() &&
    !(t.size || "").trim() &&
    !(t.dot || "").trim()
  );
}

/** Geçmiş emanet kaydından form satırı üret. */
export function tireFromHistory(s) {
  return {
    brand: s?.brand || "",
    size: s?.size || "",
    dot: s?.dot || "",
    tread_depth_mm: s?.tread_depth_mm ?? "",
    quantity: s?.quantity || 4,
    season: s?.season || "kis",
  };
}

/** Seçilen lastiği listeye yerleştir; YENİ dizi döner (mutasyon yok). */
export function placeTireFromHistory(tires, storage) {
  const picked = tireFromHistory(storage);
  const list = Array.isArray(tires) ? tires : [];
  const blankIdx = list.findIndex(isBlankTire);
  if (blankIdx === -1) return [...list, picked];
  return list.map((t, i) => (i === blankIdx ? picked : t));
}
